export default {
  serachdata: {
    unReceiveQty: '未交量',
    chooseOrderWarning: '请勾选订单编号',
    overdueFlag: '仅显示逾期未交订单',
    orderType: '订单性质',
    refuseSign: '已拒绝订单',
    supcheckbox: '当前采购员订单',
    notordercheckbox: '逾期未交订单',
    orderslsement: '订单性质',
    serachinput: '品名/订单编号/供应商',
    grant: '发放',
    lookdeliverytime: '查看交期',
    ordersjiaofu: '订单交付',
    ordersdajiao: '订单答交',
    entireok: '完全同意',
    refuse: '拒绝',
    dajiao: '受理',
    reAccept: '重新受理',
    lookjujue: '查看拒绝原因',
    fahuo: '去发货',
    lookdajiao: '查看答交',
    lookjiaoqihefashou: '查看交期表/去发货',
    yeslooknoyesorders: '已读未确认订单',
    turndown: '已拒绝订单',
    read: '已读',
    unread: '未读',
    daifafang: '待发放',
    shoulizhong: '受理中',
    jiaohuo: '交货中',
    yishouli: '已受理',
    jiean: '已结案',
    zuofei: '已作废',
    yijujue: '已拒绝',
    daishouli: '已同意',
    yiduweiqueren: '已读未确认订单',
    yijujuedingdan: '已拒绝订单',
    employeeName: '采购人员',
    yesNotongyi: '完全接受订单所有条件吗?',
    yesNofafang: '是否发放',
    yesnojujue: '确定拒绝选中订单吗?',
    jujueinfo: '请输入拒绝原因',
    checkRefuseReason: '查看拒绝原因',
    timeError: '模糊搜索开始时间不能大于结束时间',
    deleteWarning: '此操作将永久删除该文件, 是否继续?',
    goToSend: '去发货'
  },
  ordertrack: {
    receiveDate: '收货时间',
    deliveryDate: '发货时间',
    refuseSign: '受理状态',
    ticketStatus: '开票状态',
    CheckTheState: '对账状态',
    differenceType: '差错类别',
    searchPlaceholder: '输入商品名或订单编号或供应商进行搜索',
    taxPrice: '含税单价',
    a: '计价数量',
    purchaseNo: '订单单号',
    purchaseDate: '订单日期',
    purOfficeName: '采购中心',
    purChasingCenter: '采购中心',
    supplierName: '供应商',
    purchaseSeqAndPurchasePhaseSeq: '项次-项序-分批序',
    goodsNo: '料号',
    purchaseUnitName: '采购商',
    goodsName: '品名',
    grant: '发放',
    spec: '规格',
    batchPurQty: '订单量',
    unDeliveryQty: '可发货量',
    unReceiveQty: '未交量',
    deliveryQty: '发货量',
    onWayQty: '在途量',
    expectArrivalDate: '预计交货日期',
    qiwangjiaohuoDate: '期望交货日期',
    replyDeliveryNum: '交期回复次数',
    status: '状态',
    jiaoqistatus: '交期状态',
    purchaseUnitNo: '采购中心',
    purchaseDateRange: '订单日期范围',
    startPurchaseDate: '订单日期-起',
    endPurchaseDate: '订单日期-止',
    deliveryDateRange: '交货日期范围',
    startDeliveryDate: '交货日期-起',
    endDeliveryDate: '交货日期-止',
    outPurchaseNo: '外部单号',
    employeeInfo: '采购员',
    orderType: '订单性质',
    orderType1: '一般订单',
    orderType2: '委外订单',
    orderType3: 'VMI订单',
    orderTypePlaceholder: '请选择订单性质',
    overdueFlag: '仅显示逾期未交订单',
    purchaserFlag: '仅显示当前采购员订单',
    fildName: '订单信息',
    headInfo: '基础信息',
    addressStr: '地址',
    contacts: '客户联络人',
    contactPhone: '联系方式',
    employeeName: '采购人员',
    remarks: '备注',
    dataSource: '数据来源',
    exchangeRate: '交易币种/汇率',
    tranConditonName: '交易条件',
    payTermsName: '付款条件',
    sumNoTaxAmount: '未税总金额',
    sumDiffAmount: '总税额',
    sumTaxAmount: '含税总金额',
    customerInformation: '客户资料',
    documentInformation: '单据资料',
    paymentInformation: '付款信息',
    purchaseDetail: '订单详情',
    purchaseSeq: '项次',
    purchasePhaseSeq: '项序',
    batchValuationQty: '计价数量',
    unitPrice: '含税单价',
    tableTaxInfo: '未含税/含税/税额',
    taxTypeInfo: '税种/税率（%）',
    receiveQty: '收货量',
    checkReturnQty: '验退量',
    refundQty: '验退量',
    returnExchangeQty: '仓退量',
    returnExchangeQtyName: '仓退量',
    lookDelivery: '查看交期',
    lookContent: '查看详情',
    deliveryTitle: '分批明细',
    supReplyQty: '答交数量',
    supReplyDate: '答交日期',
    supReplyRemark: '备注',
    approvalRecord: '审批记录',
    operationUser: '操作人',
    operation: '操作',
    adddate: '时间',
    rejectReason: '拒绝原因',
    status0: '待确认',
    status1: '需对平',
    status2: '双方确认',
    status3: '待开票',
    status4: '已开票',
    deliveryStatus: '发货状态',
    partialDelivery: '部分发货',
    fullDelivery: '全部发货',
    partialReceipt: '部分收货',
    fullReceipt: '全部收货',
    unitNo: '单位',
    unitPriced: '单价',
    amount: '金额'
  },
  info: {
    supReplyQty: '承诺交期数量',
    supReplyDate: '承诺交货日期',
    supReplyRemark: '供应商备注',
    operation: '操作',
    return: '返回',
    purchaseUnitName: '采购中心',
    splitBtn: '拆分',
    deleteBtn: '删除',
    agree: '接受',
    reject: '拒绝',
    cancel: '取消',
    sumWarning: '承诺交期量总和不等于订单量，请检查！',
    position: '第',
    line: '行',
    supReplyDateWarning: '承诺交货日期为空，请检查！',
    successAcceptance: '同意受理成功',
    rejectReasonTip: '请输入拒绝原因',
    successReject: '拒绝受理成功',
    rejectReason: '拒绝原因',
    asnNo: '发货单号',
    deliveryStatus: '送货情况',
    sumDeliveryQty: '总发货量',
    sumReceiveQty: '总收货量',
    sendSuccess: '发放成功',
    operateTip: '仅受理中状态可进行操作'
  }
}
